export default __webpack_public_path__ + "assets/images/f8bde83e2f0734052333f95ed1015dbd.png";